<script>
export let params = {};
import Fa from 'svelte-fa'
import { faCheck, faChevronRight, faRedo, faForward } from '@fortawesome/free-solid-svg-icons';
let email = params.email;
let resetToken = params.resetToken;
let password;
let password2;


import app from '../web_feathers.js';
const new_password = app.service('new_password');
let message;
let errors;
let loading=false;
let linkToNewToken=false;
import Spinner from 'svelte-spinner';

import toast from '../web_toast.js';
import {tick} from 'svelte';
import { push } from 'svelte-spa-router';

var skippedPassword = false;
function skipPassword(){
	var crypto = window.crypto || window.msCrypto;
	const array = new Uint32Array(6);
	crypto.getRandomValues(array);
	password = password2 = array.join('--');
	skippedPassword=true;
	return request();
	}

async function request(){
	message=null;
	linkToNewToken=false;
	errors=[];
	
	if(!password) return errors.push('Please enter a passwords');//only one needed...
	if(password && password!==password2) errors.push('Passwords must match');
	if(password.length<6) errors.push('Password must be at least 6 characters long');

	if(errors.length) return;
	loading=true;
	//set X-Service-Method as a post: PATCH for kosher internet to route to patch?
	//set params (2nd variable of create) to redirect to patch?
	return new_password.patch(email, {password, resetToken})
		.then(async function(){
			//message = 'Success with change! lets log you in...';
			//await replace('/SimActivations/'+list[0].id);
			await app.login(email,password);//this line should never fail - we just set this password
			await push('/');//go to main screen
			await tick();
			if(!skippedPassword) toast('Password successfully set!','success',{duration:4000});
			})
		.catch(function(err){
			if(err.errors) errors=Object.values(err.errors) //use the values of an errors sub-object if it's there from the validation library
			//... but might be blank
			if(err.message=='Reset Link Invalid') {
				errors.push(err.message);
				linkToNewToken=true;
				return;
				}
			else if(!errors || !errors.length) errors.push(err.name +' ' + err.message);

			})
		.finally(()=>loading=false);
	}

</script>



<main>

<form>

<div class="container">
	<div class="row justify-content-md-center">
		<div class="col-lg-6 col-md-8 col-s-12">
			<h2 class="ff-dunbar">Create Password</h2>
			</div>
			</div>
		<div class="row mt-3 justify-content-md-center">
		<div class="col-lg-6 col-md-8 col-s-12">
			<label for="email" class="ff-dunbar title-2">Email</label><br>
			<input disabled class="form-control" type="email" name="email" id="email" autocomplete="email" bind:value={email}>
		</div></div>
		
		<div class="row mt-3 justify-content-md-center">
			<div class="col-lg-6 col-md-8 col-s-12">
				<label for="password" class="ff-dunbar title-2">New Password</label><br>
				<input class="form-control" type="password" minlength="6" name="password" id="password" autocomplete="passsword" bind:value={password}>
			</div></div>
		<div class="row mt-3 justify-content-md-center">
			<div class="col-lg-6 col-md-8 col-s-12">
				<label for="password2" class="ff-dunbar title-2">Retype Password</label> 
				{#if password && password==password2}
					 <Fa icon={faCheck} class="text-success" />
				{/if}
				<br>
				<input class="form-control" type="password" minlength="6" name="password2" id="password2" autocomplete="passsword" bind:value={password2}>
			</div></div>

		<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-6 col-md-8 col-s-12">
		<button disabled={loading} type="submit" class="btn btn-primary form-control" on:click|preventDefault={request}>
			{#if loading} <Spinner /> {/if}
			Set Password <Fa icon={faChevronRight}/>
			</button>
		</div></div>


		{#if window.crypto || window.msCrypto}
		<br>
		<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-4 col-md-6 col-s-8">
		<button disabled={loading} type="submit" class="btn btn-sm btn-secondary form-control" on:click|preventDefault={skipPassword}>
			{#if loading} <Spinner /> {/if}
			Skip Password <Fa icon={faForward}/>
			</button>
		</div></div>
		{/if}
	
		<div class="row justify-content-md-center">
			<div class="mt-3 col-lg-6 col-md-8 col-s-12">
		{#if message}
			<div class="alert alert-success">{message}</div>
		{:else if errors && errors.length}
			<div class="alert alert-danger">
				{#each errors as item}
					 {item}<br>
				{/each}
			{#if linkToNewToken}
				<b><a href="#/new_password/{email}" class="btn btn-primary"><Fa icon={faRedo} /> Request a new password link</a></b>
				{/if}
			</div>
			{/if}
			</div></div>

	</div>

	</form>

</main>
	